import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Calendar, Compass, Palmtree } from "lucide-react";
import { Button } from "@/components/ui/button";

const steps = [
  {
    icon: Calendar,
    title: "Book Online",
    description: "Choose your date and cabana. Entry for 8 included.",
    number: "01",
  },
  {
    icon: Compass,
    title: "Cross the Bridge",
    description: "Drive across our 100-foot wooden bridge onto your private island.",
    number: "02",
  },
  {
    icon: Palmtree,
    title: "Relax All Day",
    description: "Swim, grill, kayak, nap in a hammock. Your cabana is home base.",
    number: "03",
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 lg:py-28 bg-background scroll-mt-24">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Simple as 1-2-3
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Book, arrive, and enjoy. We handle the rest.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="group relative"
            >
              <div className="tropical-card p-8 text-center h-full">
                <div className="absolute -top-4 left-8 text-6xl font-display font-bold text-primary/10">
                  {step.number}
                </div>
                <div className="relative">
                  <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                    <step.icon className="w-8 h-8 text-primary" />
                  </div>
                  <h3 className="font-display text-xl font-semibold text-foreground mb-3">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground">{step.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="text-center"
        >
          <Button variant="tropical" size="lg" asChild>
            <Link to="/book-now">Check Availability</Link>
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;
